import { Box, Flex, Text, Heading, useColorModeValue, Icon } from "@chakra-ui/react";
import { FaPlay } from "react-icons/fa";
import { Link } from "react-router-dom";

const Card = ({ course, title, category, description, _id, img, thumbnail }) => {
  const displayImg = thumbnail || img;
  
  const cardBg = useColorModeValue("white", "gray.800");

  const cardHeadingColor = useColorModeValue("gray.800", "white");
  const cardTextColor = useColorModeValue("gray.600", "gray.400");


  // Custom gradient styles representing modern enterprise visual badges
  const fallbackGradients = [
    "linear-gradient(135deg, #2563eb 0%, #0ea5e9 100%)",
    "linear-gradient(135deg, #8b5cf6 0%, #ec4899 100%)",
    "linear-gradient(135deg, #10b981 0%, #0f766e 100%)",
    "linear-gradient(135deg, #f59e0b 0%, #e11d48 100%)"
  ];
  
  // Select a consistent gradient based on the _id to keep the visual representation deterministic
  const charSum = (_id || "").split("").reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const selectedGradient = fallbackGradients[charSum % fallbackGradients.length];

  return (
    <Link to={`/course/${_id}`} style={{ display: "block", textDecoration: "none" }}>
      <Flex
        direction="column"
        p={5}
        h="340px"
        bg={cardBg}
        borderRadius="3xl"
        boxShadow="0 10px 40px rgba(0,0,0,0.08)"
        position="relative"
        overflow="hidden"
        transition="all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)"
        _hover={{ transform: "translateY(-5px)", boxShadow: "0 15px 50px rgba(0,0,0,0.12)" }}
      >
        {/* Top Content Area */}
        <Flex justify="space-between" align="flex-start" w="full" mb={4}>
          <Box flex={1} mr={4}>
            <Heading 
              as="h4"
              size="sm" 
              fontWeight="800" 
              color={cardHeadingColor} 
              lineHeight="1.3"
              noOfLines={2} 
              mb={1}
            >
              {title}
            </Heading>
            <Text 
              fontSize="xs" 
              color={cardTextColor} 
              noOfLines={1} 
              fontWeight="600"
            >
              {category || "Corporate Module"}
            </Text>
          </Box>
          <Flex 
            bg="orange.400" 
            w="38px" h="38px" 
            borderRadius="full" 
            align="center" justify="center"
            boxShadow="0 4px 12px rgba(221, 107, 32, 0.4)"
            flexShrink={0}
          >
            <Icon as={FaPlay} color="white" boxSize={3} ml="2px" />
          </Flex>
        </Flex>

        {/* Expansive Bottom Image Area */}
        <Box w="full" flex={1} borderRadius="2xl" overflow="hidden" position="relative">
          {displayImg ? (
            <Box
              bgImage={`url(${displayImg})`}
              bgSize="cover"
              bgPos="center"
              w="full"
              h="full"
              transition="transform 0.4s ease"
              _hover={{ transform: "scale(1.05)" }}
            />
          ) : (
            <Flex 
              w="full" 
              h="full" 
              background={selectedGradient} 
              position="relative"
              align="center" 
              justify="center"
              p={6}
              textAlign="center"
            >
              {/* Translucent Logo Background Overlay */}
              <Box 
                position="absolute" 
                top={0} left={0} right={0} bottom={0} 
                bgImage="url('/logo-2.png')" 
                bgSize="50%" 
                bgRepeat="no-repeat" 
                bgPos="center" 
                opacity={0.15} 
                zIndex={0}
                style={{ mixBlendMode: 'overlay' }}
              />
              <Text 
                fontFamily="Outfit" 
                fontSize="md" 
                fontWeight="800" 
                color="white" 
                letterSpacing="-0.5px"
                lineHeight="1.2"
                textShadow="0 4px 10px rgba(0,0,0,0.15)"
                position="relative"
                zIndex={1}
              >
                {title}
              </Text>
            </Flex>
          )}
        </Box>
      </Flex>
    </Link>
  );
};

export default Card;
